// extracted by mini-css-extract-plugin
export default {"Page":"quem-somos_page_Page__VHXRk","Content":"quem-somos_page_Content__gLaGI","Text":"quem-somos_page_Text__S+Mif","Image":"quem-somos_page_Image__7Z4LM"};